import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getCompanySpecificTrainingDetails } from 'modules/activityDetails/CompanySpecificTrainingDetails/api/companySpecificTrainingDetailsService'
import {
  CompanySpecificTrainingDetailsState,
  ApiCompanySpecificTrainingDetailsResponse,
} from './types'

const initialState: CompanySpecificTrainingDetailsState = {
  companySpecificTrainingDetailsData: {},
}

const companySpecificTrainingDetailsSlice = createSlice({
  name: 'companySpecificTrainingDetails',
  initialState,
  reducers: {
    companySpecificTrainingDetailsLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiCompanySpecificTrainingDetailsResponse>>
    ) {
      state.companySpecificTrainingDetailsData = action.payload
    },
    clearCompanySpecificTrainingDetails(state) {
      state.companySpecificTrainingDetailsData = initialState.companySpecificTrainingDetailsData
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { companySpecificTrainingDetailsLoaded, clearCompanySpecificTrainingDetails } =
  companySpecificTrainingDetailsSlice.actions

export { clearCompanySpecificTrainingDetails }
export default companySpecificTrainingDetailsSlice.reducer

export const loadCompanySpecificTrainingDetailsData = (
  companySpecificTrainingId: Guid,
  resultId?: Guid
) => {
  return createApiAction({
    apiCalls: {
      companySpecificTrainingDetails: () =>
        getCompanySpecificTrainingDetails(companySpecificTrainingId, resultId),
    },
    payloadAction: companySpecificTrainingDetailsLoaded,
    getResultToKeep: state =>
      state.companySpecificTrainingDetails.companySpecificTrainingDetailsData.result,
  })
}
